export function useFilterDebugFlag() {
    return window.location.href.includes('filterDebug=true');
}